import {
  createShouldForwardProp,
  props,
} from "@styled-system/should-forward-prop";
import { ResponsiveValue } from "styled-system";
import {
  FocusOutlineProp,
  HoverBorderColorProp,
  textTransformProp,
  TextTransformProp,
  space,
  color,
  layout,
  position,
  borders,
  flexbox,
  typography,
  compose,
  SpaceProps,
  ColorProps,
  LayoutProps,
  PositionProps,
  BorderProps,
  FlexboxProps,
  TypographyProps,
  system,
  OverrideNativeElementProps,
} from "../../utils/styleFn";
import { styled, EmotionComponent } from "../../styled";
import { theme } from "../..";
import {
  styleVariant,
  sizeVariant,
  ButtonSizeProps,
  ButtonVariantProps,
} from "./styles";

export type { ButtonSizeProps } from "./styles";
export type { ButtonVariantProps } from "./styles";

export type ButtonBaseProps = {
  /** Button size variant */
  sizeVariant?: ResponsiveValue<ButtonSizeProps>;
  /** Button variant */
  variant?: ButtonVariantProps;
  /** Display the outlined button variant */
  outline?: boolean;
  /** Should button be a block */
  block?: boolean;
  /** Is button disabled */
  disabled?: boolean;
  /** Button whitespace value */
  whiteSpace?: string;
  /** Underline plain button on hover */
  underlineOnHover?: boolean;
} & FocusOutlineProp &
  HoverBorderColorProp &
  TextTransformProp &
  SpaceProps &
  ColorProps &
  LayoutProps &
  PositionProps &
  BorderProps &
  FlexboxProps &
  TypographyProps;

export type ButtonProps = OverrideNativeElementProps<ButtonBaseProps, "button">;

const shouldForwardProp = createShouldForwardProp([
  ...props,
  "color",
  "sizeVariant",
  "variant",
  "outline",
  "block",
  "textTransform",
  "hoverBorderColor",
]);

const whiteSpace = system({
  whiteSpace: {
    property: "whiteSpace",
  },
});

const styledProps = compose(
  space,
  color,
  layout,
  position,
  borders,
  flexbox,
  whiteSpace,
  typography,
  textTransformProp
);

export const Button: EmotionComponent<ButtonProps> = styled("button", {
  shouldForwardProp,
})<ButtonProps>`
  ${sizeVariant}
  ${styleVariant}

  ${styledProps}
`;

Button.displayName = "Button";

Button.defaultProps = {
  variant: "primary",
  sizeVariant: "md",
  block: false,
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  focusOutline: `1px solid ${theme.colors.secondary}`,
};

export default Button;
